module.exports = __webpack_public_path__ + "images/psp/hero/climate-controlled-hero.webp";